import { IEnv } from './env.types';

const devEnv: IEnv = {
  version: '0.0.0',
  release: '0.0.0',
  apiUrl: 'http://localhost:5055/api',
};
const createEnv = (): IEnv => {
  let result = {
    ...devEnv,
  };
  if (process.env.NODE_ENV === 'production') {
    result = window.config;
  }
  return result;
};

export const Env = createEnv();
